"use client";
import React from "react";

export default function HeroYoutube() {
  return (
    <section className="relative z-0 flex w-full flex-col items-center justify-center bg-white bg-cover p-6 lg:py-6">
      <div className="mx-auto flex flex-col items-center justify-center sm:p-6 lg:max-w-6xl lg:flex-row lg:p-0 xl:p-8">
        <div className="container relative z-20 mb-16 flex w-full flex-col px-5 pb-1 pr-12 text-2xl text-gray-700 sm:items-center sm:pr-0 md:pl-0 md:pr-6 lg:mb-0 lg:w-1/2 lg:items-start lg:pl-5 xl:pr-10">
          <h1
            className="relative z-20 text-3xl font-extrabold leading-none text-purple-500 sm:text-center lg:text-left xl:text-3xl"
            data-primary="purple-500"
          >
            Watch Dr John's Latest
            <br />
            <span className="mt-1 text-gray-800 lg:mt-0">Youtube Video</span>
          </h1>
          <p className="xl:text-l relative z-0 mt-6 block text-base text-gray-500 sm:text-center lg:text-left">
            Explore our YouTube channel for unparalleled hair solutions. Witness
            the magic of true hair transformation. Let Dr. John Watts be your
            trusted guide on this captivating journey!
          </p>
          <div className="relative mt-4 flex">
            {/* <a
              href="/top-secrets-instantly-increase-hair-density"
              className="flex items-center self-start justify-center px-2 py-2 mt-2 text-base font-small leading-tight text-white transition duration-150 ease-in-out bg-purple-500 border border-transparent rounded-full shadow lg:py-2 hover:bg-purple-600 focus:outline-none focus:border-purple-600 focus:shadow-outline-purple md:text-small xl:text-small md:px-5 xl:px-10"
              data-primary="purple-500"
              data-rounded="rounded-full"
            >
              Read Article
            </a> */}
            <a
              href="https://www.youtube.com/@dr.johnwatts"
              className="md:text-small xl:text-small relative ml-2 mt-2 flex items-center justify-center self-start rounded-full border-transparent bg-gray-100 p-2 text-base font-medium leading-tight text-gray-400 shadow-sm transition duration-150 ease-in-out hover:text-purple-500 focus:outline-none md:pl-16 md:pr-5 lg:py-2 xl:pr-10"
              data-primary="purple-500"
              data-rounded="rounded-full"
            >
              <svg
                className="absolute left-0 ml-3 size-3 md:h-10 md:w-8"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="text-purple-500" data-primary="purple-600">
                Watch Videos
              </span>
            </a>
          </div>
        </div>
        <div className="group relative w-full cursor-pointer rounded-lg px-5 lg:w-1/2 xl:px-0">
          <div className="absolute left-0 top-0 -mt-20 w-11/12 opacity-50">
            <svg
              className="ml-4 size-full text-purple-100"
              data-primary="purple-500"
              viewBox="0 0 200 200"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M45,-78C58.3,-70.3,69,-58.2,75.2,-44.4C81.3,-30.7,82.9,-15.3,83.5,0.4C84.2,16,83.8,32.1,76.5,43.9C69.2,55.7,55.1,63.3,41.2,69.4C27.3,75.4,13.6,80,-0.7,81.2C-15.1,82.5,-30.1,80.3,-41.2,72.6C-52.2,64.9,-59.2,51.6,-67.1,38.5C-75.1,25.5,-83.9,12.8,-83.8,0C-83.8,-12.7,-74.9,-25.4,-65.8,-36.4C-56.7,-47.4,-47.4,-56.7,-36.4,-65.7C-25.4,-74.7,-12.7,-83.5,1.6,-86.2C15.9,-89,31.8,-85.7,45,-78Z"
                transform="translate(100 100)"
                className=""
              ></path>
            </svg>
          </div>
          <div
            className="group relative cursor-pointer overflow-hidden rounded-md shadow-2xl"
            data-rounded="rounded-md"
            data-rounded-max="rounded-full"
          >
            <div className="absolute flex size-full items-center justify-center">
              <span
                className="flex size-20 items-center justify-center rounded-full bg-purple-500 shadow-2xl"
                data-rounded="rounded-full"
                data-primary="purple-500"
              >
                <svg
                  className="ml-1 h-8 w-auto fill-current text-white"
                  viewBox="0 0 52 66"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M50 30.7L4.1.6C2.6-.4.8.9.8 2.9v60.3c0 2 1.8 3.3 3.3 2.3L50 35.3c1.5-1 1.5-3.6 0-4.6z"
                    fillRule="nonzero"
                  ></path>
                </svg>
              </span>
            </div>
            <iframe
              src="https://www.youtube.com/embed/oOkhmFo8lq8"
              title="YouTube video player"
              className="aspect-video w-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
